import Router from "@/common/router/Router";

export default class MeterRouter extends Router {
  static BASE_PATH = "/meter";
  static SHOW_ROUTE_NAME = "meter-show";
  static CREATE_ROUTE_NAME = "meter-create";
  static UPDATE_ROUTE_NAME = "meter-update";
  static LIST_ROUTE_NAME = "meter-list";

  constructor() {
    super(
      MeterRouter.BASE_PATH,
      MeterRouter.SHOW_ROUTE_NAME,
      MeterRouter.CREATE_ROUTE_NAME,
      MeterRouter.UPDATE_ROUTE_NAME,
      MeterRouter.LIST_ROUTE_NAME
    );
  }
}

export const meterRouter = new MeterRouter();
